import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import SkeletonBlock from '@components/common/Skeleton/SkeletonBlock';

import style from './style.module.scss';

const SensorsLocationsSkeleton = () => {
  return (
    <div className={style.locationsBlock}>
      <div key={uuidv4()} className={style.locationItem}>
        <div className={style.locationName}>
          <SkeletonBlock className={style.skeletonTitle} />
        </div>
        <div className={style.sensorsBlock}>
          {[...Array(8)].map(() => (
            <div key={uuidv4()} className={style.skeletonEquipmentItem}>
              <SkeletonBlock className={style.skeletonText} />
              <SkeletonBlock className={style.skeletonItems} />
              <SkeletonBlock className={style.skeletonText} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SensorsLocationsSkeleton;
